import { Suspense } from 'react'

import { EventMetric } from '@tribeplatform/gql-client/types'
import { AnalyticsSectionTitle } from '@tribeplatform/react-components/Analytics/components'
import { TopEventsList } from '@tribeplatform/react-components/Analytics/lists/Event/TopEventsList'
import { useI18n } from '@tribeplatform/react-components/i18n'
import { Container, GridList } from '@tribeplatform/react-ui-kit/Layout'

export const EventsAnalytics = () => {
  const { $t } = useI18n()

  return (
    <Container size="lg">
      <GridList columns={3}>
        <div className="col-span-full flex justify-between web:flex-col web:md:flex-row p-1">
          <AnalyticsSectionTitle
            title={$t({
              defaultMessage: 'Events',
              id: 'Generics.Events',
            })}
          />
        </div>
        <Suspense>
          <TopEventsList metric={EventMetric.uniqueVisitors} />
          <TopEventsList metric={EventMetric.uniqueRegistrants} />
          <TopEventsList metric={EventMetric.conversionRatio} />
        </Suspense>
      </GridList>
    </Container>
  )
}
